class GuideModel {
    constructor({
        id = "",
        routeId = "",
        description = "",
        content = "",
        hasGuide = false,
        createdAt = null,
        createdBy = "",
        updatedAt = null,
        updatedBy = "",
    } = {}) {
        this.id = id;
        this.routeId = routeId;
        this.description = description;
        this.content = content;
        this.hasGuide = hasGuide;
        this.createdAt = createdAt;
        this.createdBy = createdBy;
        this.updatedAt = updatedAt;
        this.updatedBy = updatedBy;
    }

    static getAttributes(filter = null, validationSchema = null) {
        const attributes = {
            id: {
                'label': 'ID',
                'sortable': true,
                'sortField': 'id',
                'value': (item) => item.id || "",
            },
            routeId: {
                'label': 'Route',
                'sortable': true,
                'sortField': 'routeId',
                'value': (item) => item.routeId || "",
            },
            description: {
                'label': 'Description',
                'sortable': true,
                'sortField': 'description',
                'value': (item) => item.description || "",
            },
            content: {
                'label': 'Content',
                'sortable': false,
                'sortField': 'content',
                'value': (item) => item.content || "",
            },
            hasGuide: {
                'label': 'Has Guide',
                'sortable': true,
                'sortField': 'hasGuide',
                'showInFilter': false,
                'value': (item) => item.hasGuide ? 'Yes' : 'No',
            },
            updatedAt: {
                'label': 'Updated At',
                'sortable': true,
                'sortField': 'updatedAt',
                'showInFilter': false,
                'value': (item) => item.updatedAt
                    ? new Date(item.updatedAt).toLocaleDateString()
                    : "",
            },
            updatedBy: {
                'label': 'Updated By',
                'sortable': true,
                'sortField': 'updatedBy',
                'value': (item) => item.updatedBy || "",
            },
        };

        return attributes;
    }
}

export default GuideModel;